<template>
  <div v-if="syncAccount">
    <popup-add-venue ref="popupAddVenue" />
    <popup-add-venue-alias ref="popupAddVenueAlias" />
    <vx-card no-shadow>
      <vs-breadcrumb class="mt-2">
        <li>
          <router-link to="/crm/engage/configuration">
            Engage configuration</router-link
          ><span class="vs-breadcrum--separator">/</span>
        </li>
        <li aria-current="page" class="active">Edit sync acccount</li>
      </vs-breadcrumb>

      <div class="vx-row mb-6 mt-2">
        <div class="vx-col sm:w-2/5 w-full">
          <h2>Sync account</h2>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Account email:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <p>{{ syncAccount.id }}</p>
        </div>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Emails:</span>
        </div>
        <div class="vx-col sm:w-2/5 w-full">
          <vs-row vs-justify="space-between" class="mb-2">
            <p>{{ syncAccount.venues.length }}/98 venues added</p>
            <div
              class="cursor-pointer"
              v-if="
                syncAccount.venues.length < 98 &&
                hasPermission(
                  'vp.crm.engageconfiguration.emailsynclist.createedit'
                )
              "
              @click="$refs.popupAddVenue.show(accountId)"
            >
              <span class="flex items-center text-dark text-muted-style">
                <feather-icon
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="mr-2"
                />
                <span>Add venue</span>
              </span>
            </div>
          </vs-row>

          <vs-list>
            <div v-for="venue in syncAccount.venues" :key="venue.venueName">
              <vs-list-header
                color="warning"
                :title="`${venue.venueName}`"
              ></vs-list-header>
              <vs-list-item :title="venue.email" subtitle="Primary group email">
                <feather-icon
                  v-if="
                    hasPermission(
                      'vp.crm.engageconfiguration.emailsynclist.createedit'
                    )
                  "
                  @click="confirmRemove(venue.venueId)"
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  class="cursor-pointer ml-1"
                  size="small"
                ></feather-icon>
              </vs-list-item>
              <vs-list-item
                v-for="(alias, idx) in venue.aliases"
                :key="idx"
                :title="alias"
                subtitle="Email alias (receive only)"
              >
                <feather-icon
                  v-if="
                    hasPermission(
                      'vp.crm.engageconfiguration.emailsynclist.createedit'
                    )
                  "
                  @click="confirmRemoveAlias(venue.venueId, alias)"
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  class="cursor-pointer ml-1"
                  size="small"
                ></feather-icon>
              </vs-list-item>
              <vs-list-item title="" subtitle="Add new alias">
                <feather-icon
                  v-if="
                    hasPermission(
                      'vp.crm.engageconfiguration.emailsynclist.createedit'
                    )
                  "
                  @click="$refs.popupAddVenueAlias.show(accountId, venue.venueId)"
                  icon="PlusIcon"
                  svgClasses="h-4 w-4"
                  class="cursor-pointer ml-1"
                  size="small"
                ></feather-icon>
              </vs-list-item>
            </div>
          </vs-list>
        </div>
      </div>

      <!-- Save & Remove Button -->
      <!--<vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button
          id="remove-button"
          @click="confirmRemove"
          color="danger"
          disabled="true"
          class="mt-2"
          >Remove</vs-button
        >
        <vs-button disabled="true" id="save-button" @click="update" class="mt-2"
          >Update</vs-button
        >
      </vs-row>-->
      <vs-row
        vs-justify="space-between"
        class="flex flex-wrap items-center"
        style="margin-top: 32px"
      >
        <vs-button @click="back" class="mt-2">Back</vs-button>
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import popupAddVenue from "./PopupAddVenue.vue";
import popupAddVenueAlias from "./PopupAddVenueAlias.vue";

export default {
  components: { popupAddVenue, popupAddVenueAlias },
  props: {},
  data() {
    return {
      accountId: "",
      venueToRemove: "",
      aliasToRemove: "",
    };
  },
  methods: {
    async confirmRemove(venueId) {
      this.venueToRemove = venueId;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to remove this venue?",
        accept: this.removeVenue,
      });
    },
    async confirmRemoveAlias(venue, alias) {
      this.aliasToRemove = alias;
      this.venueToRemove = venue;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Are you sure you want to remove this alias?",
        accept: this.removeAlias,
      });
    },
    async remove() {
      /*this.$vs.loading();
      await this.$store.dispatch("emailTemplates/delete", this.templateId);
      this.$vs.loading.close();
      this.$router.go(-1);*/
    },
    async back() {
      this.$router.go(-1);
    },
    async update() {},
    async addAlias() {
      const dto = {
        venueId: this.venueToRemove,
        alias: this.aliasToRemove,
        syncEmail: this.accountId,
      };

      this.$vs.loading();

      await this.$store.dispatch("email/addSyncVenueAlias", dto);

      this.$vs.notify({
        color: "success",
        title: `Alias removed`,
        text: "Alias removed",
      });
      this.$vs.loading.close();
    },
    async removeAlias() {
      const dto = {
        venueId: this.venueToRemove,
        alias: this.aliasToRemove,
        syncEmail: this.accountId,
      };

      this.$vs.loading();

      await this.$store.dispatch("email/removeSyncVenueAlias", dto);

      this.$vs.notify({
        color: "success",
        title: `Alias removed`,
        text: "Alias removed",
      });
      this.$vs.loading.close();
    },
    async removeVenue() {
      const dto = {
        venueId: this.venueToRemove,
        syncEmail: this.accountId,
      };

      this.$vs.loading();

      await this.$store.dispatch("email/removeSyncVenue", dto);

      this.$vs.notify({
        color: "success",
        title: `Venue removed`,
        text: "Venue removed",
      });
      this.$vs.loading.close();
    },
  },
  computed: {
    ...mapGetters({}),
    /*consentTypeOptions() {
      return this.consentTypes.map((e, i) => {
        return { text: e, value: i };
      });
    },*/
    syncAccount() {
      return this.$store.getters["email/emailSyncItem"](this.accountId);
    },
  },
  async created() {
    this.accountId = this.$route.params.id;
    await this.$store.dispatch("email/getSyncItems", false);
    console.log(this.syncAccount);
  },
};
</script>

<style lang="scss">
</style>